import { Injectable } from '@angular/core';
import { ROUTER_PATHS } from '../constants';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private readonly router: Router) {}

  navigateToDashboard() {
    this.router.navigate([ROUTER_PATHS.root, ROUTER_PATHS.dashboard.root]);
  }

  navigate(commands: [], navigationExtras?: { [key: string]: any } | undefined): Promise<boolean> {
    return this.router.navigate(commands, navigationExtras);
  }
}
